export const pagesAttendancesEn = {
  alerts: {
    actions: {
      attendanceGuidance: 'Attendance guidance',
      overtimeCorrective: 'Overtime corrective',
      toastDescription: 'This action is not available in the demo.',
      toastTitle: 'Action'
    },
    categories: {
      all: 'All',
      interval: 'Work interval',
      irregular: 'Attendance issues',
      leave: 'Leave usage',
      overtime: 'Overtime hours'
    },
    toolbar: {
      employeeChip: 'Employee',
      employmentTypeChip: 'Employment type',
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export',
      filterChip: 'Filter',
      fullscreenAria: 'Fullscreen',
      fullscreenToastDescription: 'Fullscreen is not available in the demo.',
      fullscreenToastTitle: 'Fullscreen',
      searchPlaceholder: 'Search…',
      shareAria: 'Share',
      shareToastDescription: 'Share is not available in the demo.',
      shareToastTitle: 'Share'
    },
    types: {
      annual_360h_exceeded: '360h annual exceeded',
      consecutive_overtime: 'Consecutive overtime',
      early_leave: 'Frequent early leave',
      holiday_work: 'Holiday work',
      interval_violation: 'Interval violation',
      late_arrival: 'Frequent late arrival',
      monthly_80h_exceeded: '80h monthly exceeded',
      no_clock_in: 'No clock-in',
      no_clock_out: 'No clock-out',
      overtime_limit: 'Overtime limit'
    }
  },
  analysis: {
    chart: {
      list: {
        helpTooltip: 'Number of saved analyses grouped by type.',
        series: {
          count: 'Analyses'
        },
        title: 'Saved analyses by type'
      },
      nightHolidayWork: {
        helpTooltip: 'Night (22:00–05:00) and holiday hours by department, used to spot work concentrating on a few people.',
        title: 'Night and holiday work by department'
      },
      overtimeTrend: {
        helpTooltip: 'Monthly average and maximum overtime against the 45h limit agreed in the Article 36 agreement.',
        title: 'Monthly overtime trend'
      },
      paidLeaveRate: {
        helpTooltip: 'Share of granted annual leave actually taken, by department.',
        title: 'Paid leave utilisation by department'
      }
    },
    columns: {
      analysisName: 'Analysis',
      author: 'Author',
      averageOvertimeHours: 'Avg. overtime',
      department: 'Department',
      grantedDays: 'Granted',
      headcount: 'Headcount',
      holidayWorkHours: 'Holiday work',
      maxOvertimeHours: 'Max overtime',
      nightHours: 'Night work',
      obligationUnmetCount: '5-day duty unmet',
      over45Count: 'Over 45h',
      over80Count: 'Over 80h',
      status: 'Status',
      takenDays: 'Taken',
      takenRate: 'Utilisation',
      targetMonth: 'Month',
      topQuintileShare: 'Top 20% share',
      type: 'Type',
      updatedAt: 'Updated'
    },
    empty: 'No analysis data.',
    list: 'Analyses',
    recent: {
      nightHolidayWork: 'Night / holiday work concentration',
      overtimeTrend: 'Overtime trend',
      paidLeaveRate: 'Paid leave utilisation',
      title: 'Recent analyses'
    },
    showSummary: 'Show summary',
    startNew: 'New analysis',
    status: {
      archived: 'Archived',
      draft: 'Draft',
      published: 'Published'
    },
    title: 'Analysis'
  },
  contractAndCost: {
    chart: {
      cost: {
        helpTooltip: 'Monthly labour cost derived from attendance: contracted hours plus statutory premiums.',
        title: 'Labour cost trend'
      },
      payment: {
        helpTooltip: 'Monthly breakdown of the hours that feed payroll: scheduled, overtime and night / holiday work.',
        title: 'Payable hours cost trend'
      }
    },
    empty: {
      subtitle: 'No attendance records in the selected 12 months.',
      title: 'No records for this period'
    },
    grid: {
      entityHeader: {
        department: 'Department',
        member: 'Employee'
      },
      item: 'Item',
      loadError: 'Could not load the data.',
      total: 'Total',
      trend: 'Trend'
    },
    rows: {
      nightHolidayCost: 'Night / holiday premium',
      overtimeCost: 'Overtime premium',
      premiumCost: 'Premium pay',
      scheduledCost: 'Scheduled hours pay',
      totalLaborCost: 'Labour cost'
    },
    statCards: {
      comparison: {
        PREVIOUS_MONTH: 'vs. previous month',
        PREVIOUS_YEAR: 'vs. same month last year'
      },
      cost: {
        periodTotal: 'Labour cost (12-month total)',
        premiumCost: 'Premium pay',
        premiumCostTooltip: 'Overtime, night and holiday premiums combined — the part of labour cost that attendance can move.',
        scheduledCost: 'Scheduled hours pay',
        scheduledCostTooltip: 'Hours worked within the contracted schedule, valued at the contracted hourly rate.',
        totalLaborCost: 'Labour cost',
        totalLaborCostTooltip: 'Scheduled hours pay plus all statutory premiums, based on recorded attendance.'
      },
      headcount: '{{count}} people',
      latestMonth: 'as of {{month}}',
      noData: '–',
      payment: {
        nightHolidayCost: 'Night / holiday premium',
        nightHolidayCostTooltip: 'Night work (22:00–05:00, +25%) and legal holiday work (+35%) premiums.',
        overtimeCost: 'Overtime premium',
        overtimeCostTooltip: 'Statutory overtime valued at 125% of the contracted hourly rate.',
        periodTotal: 'Payable pay (12-month total)',
        scheduledCost: 'Scheduled hours pay',
        scheduledCostTooltip: 'Hours worked within the contracted schedule, valued at the contracted hourly rate.'
      },
      periodHours: '{{hours}} h worked / {{count}} people'
    }
  },
  employees: {
    filterPlaceholder: 'Search by name…',
    organizationFilter: 'Organization',
    organizationSearchPlaceholder: 'Search organization…',
    statusFilter: {
      active: 'Active',
      all: 'All',
      on_leave: 'On leave',
      retired: 'Retirement scheduled'
    }
  },
  operationActivity: {
    activityTypes: {
      'alert.acknowledged': 'Alert acknowledged',
      'alert.resolved': 'Alert resolved',
      'alert.triggered': 'Alert triggered',
      'attendance.monthlyClosed': 'Monthly closed',
      'attendance.reopened': 'Monthly reopened',
      'clocking.approved': 'Clocking edit approved',
      'clocking.created': 'Clocking added',
      'clocking.deleted': 'Clocking deleted',
      'clocking.edited': 'Clocking edited',
      'clocking.rejected': 'Clocking edit rejected',
      'policy.attendanceStructureAssigned': 'Work structure assigned',
      'policy.ruleUpdated': 'Rule updated',
      'request.approved': 'Request approved',
      'request.cancelled': 'Request cancelled',
      'request.holidayWorkSubmitted': 'Holiday work request submitted',
      'request.leaveSubmitted': 'Leave request submitted',
      'request.overtimeSubmitted': 'Overtime request submitted',
      'request.rejected': 'Request rejected',
      'shift.assigned': 'Shift assigned'
    },
    actorSystem: 'System',
    categories: {
      alert: 'Alert',
      clocking: 'Clocking',
      policy: 'Rule / Shift',
      request: 'Request'
    },
    columns: {
      activityType: 'Activity',
      actor: 'Actor',
      detail: 'Detail',
      occurredAt: 'Occurred at',
      origin: 'Origin',
      target: 'Target employee'
    },
    filterByDate: 'Filter by date',
    originManual: 'Manual',
    pageTitle: 'Operation activity',
    showSummary: 'Show summary',
    summary: {
      alertsResolved: 'Alerts resolved',
      clockingCorrections: 'Clocking corrections',
      events: 'events',
      requestApprovals: 'Request approvals',
      targets: 'targets',
      thisMonth: 'This month',
      thisTerm: 'This term',
      thisWeek: 'This week'
    }
  },
  overview: {
    bands: {
      hourSuffix: 'h'
    },
    cards: {
      absenceRate: 'Absence rate',
      clockingGap: 'Clocking gap',
      longOvertime: 'Long overtime',
      monthlyOvertimeAverage: 'Monthly overtime (average)',
      monthlyOvertimeMedian: 'Monthly overtime (median)',
      paidLeaveUtilization: 'Paid leave utilization',
      remoteWorkRate: 'Remote work rate',
      sickLeaveRate: 'Sick leave rate'
    },
    loading: 'Loading…',
    offices: {
      fukuoka: 'Fukuoka',
      osaka: 'Osaka',
      sapporo: 'Sapporo',
      sendai: 'Sendai',
      tokyo_hq: 'Tokyo HQ'
    },
    organizations: {
      all: 'All organizations',
      searchPlaceholder: 'Search…'
    },
    overflowAria: '{{count}} more',
    periods: {
      fiscalYears: {
        fy2024: 'FY2024',
        fy2025: 'FY2025'
      },
      months: {
        feb: 'Feb 2026',
        jan: 'Jan 2026',
        mar: 'Mar 2026'
      },
      searchPlaceholder: 'Search…'
    },
    trend: {
      dailyAverage: 'Daily average',
      forecastEnd: 'Forecast end of month',
      markerDate: 'Day {{day}}',
      markerPrimary: '{{hours}} h',
      monthlyCap: 'Monthly cap {{hours}} h',
      title: 'Monthly overtime trend'
    },
    units: {
      hours: 'h',
      hoursShort: 'h',
      minutes: 'min',
      people: 'people',
      percent: '%'
    }
  },
  pageTitle: 'Time & Attendance Book',
  records: {
    approval: {
      approved: 'Approved',
      approvedBadge: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected'
    },
    detail: {
      noRecords: 'No clocking records.'
    },
    employeeDetail: {
      attendanceBook: {
        attendanceStatusLabel: {
          absent: 'Absent',
          early_leave: 'Early leave',
          holiday: 'Holiday',
          late: 'Late',
          non_working_day: 'Non-working day',
          paid_leave: 'Paid leave',
          present: 'Present',
          sick_leave: 'Sick leave'
        },
        empty: 'Select a month to view the attendance book.',
        emptyFiltered: 'No rows match the current filters.',
        emptyPeriod: 'No attendance records for this period.',
        filters: {
          pendingOnly: 'Pending only',
          summaryVisible: 'Show summary'
        },
        summary: {
          absentDaysLabel: 'Absence days',
          earlyLeaveLabel: 'Early leave',
          lateLabel: 'Late arrivals',
          overtimeLabel: 'Overtime',
          paidLeaveDaysLabel: 'Paid leave days',
          remoteDaysLabel: 'Remote days',
          units: {
            times: 'times'
          },
          workingDaysLabel: 'Working days',
          workingDaysValue: '{{current}} / {{total}}',
          workingHoursLabel: 'Working hours'
        },
        workCategory: {
          absent: 'Absent',
          early_leave: 'Early leave',
          holiday: 'Holiday',
          late: 'Late',
          non_working_day: 'Non-working day',
          paid_leave: 'Paid leave',
          present: 'Work',
          sick_leave: 'Sick leave'
        }
      },
      breadcrumb: {
        attendances: 'Attendance book',
        clockingRecords: 'Attendance book list'
      },
      documentTitle: '{{name}} — Attendances',
      files: {
        actions: {
          back: 'Back',
          delete: 'Delete',
          deleteToastDescription: 'Delete is not available in the demo.',
          deleteToastTitle: 'Delete',
          download: 'Download',
          downloadToastDescription: 'Download is not available in the demo.',
          downloadToastTitle: 'Download',
          openFolder: 'Open {{folderName}}',
          previewToastDescription: 'Preview is not available in the demo.',
          previewToastTitle: 'Preview',
          rename: 'Rename',
          renameToastDescription: 'Rename is not available in the demo.',
          renameToastTitle: 'Rename'
        },
        columns: {
          fileCount: 'Files',
          fileName: 'File name',
          folder: 'Folder',
          owner: 'Member',
          updatedAt: 'Updated',
          uploadedBy: 'Uploaded by'
        },
        folders: {
          attendanceBook: 'Attendance book',
          leaveRequest: 'Leave requests',
          shiftTable: 'Shift schedule'
        },
        title: 'Files'
      },
      overview: {
        alertSummaryTitle: 'Unresolved alerts',
        emptyMembers: 'No data for this period.',
        kpi: {
          avgOvertime: 'Avg. overtime (per person)',
          members: 'Total attendees',
          totalWorkHours: 'Total working hours',
          unresolvedAlerts: 'Alerts to address'
        },
        overtimeRankingTitle: 'Overtime by member',
        selfSummaryTitle: 'This month',
        units: {
          cases: 'cases',
          hours: 'h',
          people: 'people'
        },
        viewAlerts: 'View alerts'
      },
      pageTitlePrefix: 'Attendance book:',
      scope: {
        ariaLabel: 'Switch attendance book target',
        selfHint: 'Your own attendance book',
        storeHint: 'Members working at your store',
        team: 'My team',
        teamHint: 'Members of your team'
      },
      tabPlaceholderSubtitle: 'This tab is not available in the demo.',
      tabPlaceholderTitle: 'Coming soon',
      tabs: {
        alerts: 'Alerts',
        attendanceBook: 'Attendance book',
        files: 'Files',
        overview: 'Overview',
        settings: 'Settings'
      },
      tabsAriaLabel: 'Employee attendance sections',
      toolbar: {
        exportPdfAria: 'Download PDF',
        exportPdfTooltip: 'Download PDF',
        exportToastDescription: 'PDF export is not available in the demo.',
        exportToastTitle: 'PDF',
        nextMonth: 'Next month',
        prevMonth: 'Previous month',
        selectPeriod: 'Select month'
      }
    },
    filters: {
      approvalAll: 'All approvals',
      employeeChip: 'Employee',
      employmentTypeChip: 'Employment type',
      filterChip: 'Filter',
      workplaceAll: 'All workplaces'
    },
    ledger: {
      columns: {
        closedDate: 'Closed on',
        employeeCount: 'Employees',
        operation: 'Operation',
        overtimeHours: 'Overtime',
        pendingCount: 'Pending',
        recordName: 'Record name',
        status: 'Status',
        workHours: 'Actual hours'
      },
      empty: 'No attendance closings match the current filters.',
      error: 'Could not load attendance closings.',
      filterTabs: {
        all: 'All',
        ariaLabel: 'Filter by operation kind'
      },
      openDailyList: 'Daily clocking records',
      recordNameFormat: '{{period}} {{attendanceStructure}}',
      searchPlaceholder: 'Search by period or work pattern',
      status: {
        closed: 'Closed',
        collecting: 'Collecting',
        reviewing: 'Reviewing'
      }
    },
    methods: {
      biometric: 'Biometric',
      ic_card: 'IC card',
      manual: 'Manual',
      mobile: 'Mobile',
      web: 'Web'
    },
    toolbar: {
      displayDaily: 'Daily',
      displayLabel: 'Display',
      export: 'Export',
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export',
      fullscreenAria: 'Fullscreen',
      fullscreenToastDescription: 'Fullscreen is not available in the demo.',
      fullscreenToastTitle: 'Fullscreen',
      nextMonth: 'Next month',
      prevMonth: 'Previous month',
      searchPlaceholder: 'Search…',
      selectPeriod: 'Select month'
    },
    types: {
      break_end: 'Break end',
      break_start: 'Break start',
      clock_in: 'Clock in',
      clock_out: 'Clock out'
    }
  },
  reports: {
    categories: {
      inHouse: 'In-house reports',
      individual: 'Individual',
      organization: 'Establishment'
    },
    closingStatus: {
      closed: 'Closed',
      pending: '{{count}} pending'
    },
    columns: {
      absenceDays: 'Absence days',
      averageOvertimeHours: 'Avg. overtime',
      averageTakenDays: 'Avg. days taken',
      closingStatus: 'Closing',
      daysWorked: 'Days worked',
      department: 'Department',
      employee: 'Employee',
      fiscalYear: 'Fiscal year',
      grantDate: 'Grant date',
      grantedDays: 'Granted days',
      headcount: 'Headcount',
      holidayWorkHours: 'Holiday work',
      interviewRequired: 'Doctor interview',
      lateCount: 'Late arrivals',
      lateEarlyLeaveCount: 'Late / early leave',
      maxOvertimeHours: 'Max overtime',
      measurementMethod: 'Record method',
      nightHours: 'Night work',
      obligation: '5-day duty',
      obligationMetCount: 'Met',
      obligationTargets: 'Subject to duty',
      obligationUnmetCount: 'Unmet',
      over45Count: 'Over 45h',
      over80Count: 'Over 80h',
      overtimeHours: 'Overtime',
      paidLeaveDays: 'Paid leave days',
      presenceHours: 'Time on site',
      remainingDays: 'Remaining',
      scheduledWorkHours: 'Scheduled hours',
      scheduledWorkdays: 'Scheduled days',
      takenDays: 'Days taken',
      takenRate: 'Utilisation',
      targetMonth: 'Month',
      totalOvertimeHours: 'Total overtime',
      totalWorkHours: 'Working hours'
    },
    empty: 'No data for this report.',
    error: 'Could not load the report.',
    inHouseColumns: {
      approvedCount: 'Approved',
      assignedShifts: 'Assigned',
      averageLeadDays: 'Avg. lead time (days)',
      averageOvertimeHours: 'Avg. overtime',
      department: 'Department',
      fulfillmentRate: 'Fulfilment',
      headcount: 'Headcount',
      limitUsageRate: '45h limit usage',
      pendingCount: 'Pending',
      rank: 'Rank',
      rejectedCount: 'Rejected',
      requiredShifts: 'Required',
      status: 'Status',
      submittedCount: 'Submitted',
      totalOvertimeHours: 'Total overtime',
      trend: 'Trend',
      uncoveredShifts: 'Uncovered',
      workplace: 'Workplace'
    },
    interviewRequired: {
      notRequired: 'Not required',
      required: 'Required'
    },
    measurementMethod: {
      timeClock: 'Time clock'
    },
    names: {
      annualPaidLeaveLedger: 'Annual paid leave ledger',
      attendanceBook: 'Attendance book',
      clockingCorrectionSummary: 'Clocking correction summary',
      departmentOvertimeRanking: 'Overtime ranking by department',
      monthlyAttendanceSummary: 'Monthly attendance summary',
      overtimeAgreementReport: 'Article 36 overtime record',
      paidLeaveObligationReport: 'Five-day leave duty tracker',
      shiftFulfillment: 'Shift fulfilment',
      workingHoursRecord: 'Working hours status record'
    },
    obligation: {
      met: 'Met',
      unmet: 'Unmet'
    },
    searchPlaceholder: 'Search…',
    shiftStatus: {
      good: 'Good',
      risk: 'Risk',
      watch: 'Watch'
    },
    sidebar: {
      close: 'Collapse sidebar',
      open: 'Expand sidebar',
      reportsTitle: 'Reports',
      title: 'Reports'
    },
    trend: {
      down: 'Down',
      flat: 'Flat',
      up: 'Up'
    }
  },
  ruleAndPolicy: {
    categories: {
      assignment: 'Assignment rules',
      attendance: 'Attendance rules',
      period: 'Period rules'
    },
    categoryDescriptions: {
      assignment: 'Decides which employees a work-interval, holiday calendar, shift group or approver applies to. Rules are evaluated top down and only the first match applies.',
      attendance: 'Decides how recorded time is counted: breaks, overtime, night work and the Article 36 caps.',
      period: 'Decides when a period starts and when a filing is due: leave grant dates, Article 36 filing and expiry of special leave.'
    },
    clauses: {
      dueDate: 'Due date',
      organization: 'Organisation',
      peopleGroup: 'Target group',
      request: 'Named individuals',
      workerType: 'Employment type'
    },
    detail: {
      dueDateTemplate: 'Template {{templateId}}',
      memberCount: '{{count}} people'
    },
    loadError: 'Could not load the attendance rules.',
    ruleName: 'Attendance rule',
    sideTab: {
      closeSideTab: 'Collapse side tab',
      rules: 'Rules'
    },
    table: {
      columns: {
        clauseTypes: 'Conditions',
        memberCount: 'Employees covered',
        order: 'Order',
        ruleName: 'Rule',
        summary: 'Applied setting'
      },
      mandatory: 'Statutory',
      notCountable: '—',
      searchPlaceholder: 'Search rules'
    }
  },
  settings: {
    add: 'Add',
    columns: {
      attendanceStructures: 'Work structures',
      exportProfile: 'Output',
      itemCount: 'Items',
      name: 'Layout',
      period: 'Effective period',
      periodUnit: 'Aggregation',
      retention: 'Retention'
    },
    editor: {
      addItem: 'Add item',
      createTitle: 'New layout',
      discardConfirm: 'Discard unsaved changes?',
      discardConfirmCancel: 'Keep editing',
      discardConfirmOk: 'Discard',
      editTitle: '{{name}}',
      emptySlot: 'No items yet.',
      itemColumns: {
        actions: 'Actions',
        aggregation: 'Aggregation',
        field: 'Attendance item',
        label: 'Column heading',
        unit: 'Unit',
        visible: 'Show'
      },
      moveDown: 'Move down',
      moveUp: 'Move up',
      saveCreate: 'Create',
      saveErrorToast: 'Could not save the layout.',
      saveUpdate: 'Save',
      savedToast: 'Layout saved.',
      sections: {
        application: 'Scope',
        basic: 'Basics'
      },
      selectFieldPlaceholder: 'Select an item',
      slots: {
        body: 'Detail rows',
        header: 'Header fields'
      },
      tabs: {
        detail: 'Details',
        items: 'Items',
        preview: 'Document preview'
      }
    },
    empty: {
      addManually: 'Add manually',
      description: 'No layouts yet.'
    },
    enums: {
      aggregation: {
        count: 'Count',
        latest: 'Latest',
        none: 'Per row',
        sum: 'Sum'
      },
      exportProfile: {
        csv: 'CSV',
        excel: 'Excel',
        pdf: 'PDF'
      },
      periodUnit: {
        monthly: 'Monthly',
        yearly: 'Yearly'
      },
      unit: {
        count: 'Count',
        days: 'Days',
        hours: 'Hours',
        text: 'Text',
        time: 'Time'
      }
    },
    error: {
      retry: 'Reload',
      title: 'Could not load the layouts.'
    },
    errors: {
      bodyRequired: 'Add at least one detail row.',
      nameRequired: 'Enter a layout name.',
      periodRequired: 'Select a start date.',
      periodReversed: 'The end date is before the start date.'
    },
    fields: {
      attendanceStructures: 'Applies to work structures',
      attendanceStructuresPlaceholder: 'e.g. Fixed hours (monthly), Flexitime (1-month settlement)',
      exportProfile: 'Output format',
      name: 'Layout name',
      period: 'Effective period',
      periodUnit: 'Aggregation unit',
      retention: 'Retention period'
    },
    kinds: {
      attendanceBook: {
        description: 'The attendance book required by Article 108 of the Labour Standards Act. Defines which daily times are recorded and in what order they are printed.',
        title: 'Attendance book'
      },
      attendanceSummary: {
        description: 'Monthly attendance roll-up by department, used for internal review before the payroll cut-off.',
        title: 'Monthly attendance summary'
      },
      inHouseReport: {
        description: 'Tenant-specific attendance reports that are not statutory forms.',
        title: 'In-house reports'
      },
      overtimeAgreement: {
        description: 'Form 9 of the Article 36 agreement. Defines the agreed daily, monthly and yearly overtime limits filed with the Labour Standards Inspection Office.',
        title: 'Article 36 agreement'
      },
      paidLeaveLedger: {
        description: 'The annual paid leave ledger required by Article 24-7 of the Labour Standards Act Enforcement Regulations: grant date, days taken and the dates they were taken.',
        title: 'Annual paid leave ledger'
      },
      workingHoursRecord: {
        description: 'The record of working-hours status required by Article 66-8-3 of the Industrial Safety and Health Act, used to decide who needs a doctor interview.',
        title: 'Working hours status record'
      }
    },
    navigation: {
      attendanceBooks: 'Attendance books',
      attendanceSummaries: 'Attendance summaries',
      inHouseReports: 'In-house reports',
      label: 'Attendance settings',
      overtimeAgreements: 'Article 36 agreements',
      paidLeaveLedgers: 'Paid leave ledgers',
      sections: {
        individual: 'Individual documents',
        organization: 'Establishment documents'
      },
      workingHoursRecords: 'Working hours records'
    },
    noStructures: 'All work structures',
    outOfPeriod: 'Out of period',
    periodOpenEnded: 'Open-ended',
    preview: {
      noItems: 'Add detail rows to preview the document.',
      retentionNote: 'Retained for {{count}} years after the last entry.',
      untitled: 'Untitled layout'
    },
    retentionYears: '{{count}} years',
    searchPlaceholder: 'Search layouts…',
    showOutOfPeriod: 'Show out-of-period layouts',
    statutoryNotice: {
      description: 'The statutory form expects these items: {{fields}}. You can still save, but the document will not be complete.',
      title: 'Missing statutory items'
    }
  },
  tabs: {
    alerts: 'Alerts',
    contractAndCost: 'Contract & Cost',
    employees: 'Employees',
    operationActivity: 'Operation activity',
    overview: 'Overview',
    /** The attendance ledger; one row is a single employee-month */
    records: 'Records',
    reports: 'Analysis & Reports',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings'
  }
};